<template>
    <v-dialog
      v-model ="approvedialogProp"
      persistent
      max-width="500"
    >
      <v-card class="pad-10">
        <!-- <v-card-title class=""> -->
          <p class="text-center"><b>CLOSE TRADE </b></p>
          <p class="text-center font-weight-bold">*You are about <span class="green--text">approving</span> {{transaction.roomName}} Trade*</p>
        <!-- </v-card-title> -->
        
        <v-btn
            icon
            absolute
            top
            right
            @click="$emit('closeModal')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        <v-card-text>
          <information-box
            :store="transaction.transaction.giftcard.store.name"
            :amount="Number(newAmount)"
            :giftcard = "giftcardName"
            :rate = "transaction.transaction.giftcard.rate"
          />

          <label for="">Vendor</label>
            <v-select :items="vendorOptions" v-model="vendor"  outlined
              ></v-select>
          <v-checkbox
            v-model="checkbox1"
            color="auto"
            label="Confirm you are about accepting this trade"
            ></v-checkbox>
          <default-button :loading="loading" :disabled="!isComplete" @click="approveTrade()">Approve Trade</default-button>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
// =============== IMPORT COMPONENT ==============
import DefaultButton from "@/components/Buttons/default-button.vue";
import InformationBox from "./information-box.vue"

// ================= IMPORT SERVICES ===============
import { StoresService } from "@/services";
import { CloseTradeEnum } from "@/enums"

import { analytics, LogEvent } from "@/utils/firebase";

export default {
    props:{
        approvedialogProp:{
            type:Boolean,
        },
        transaction:{
          type:Object
        },
    },
    components: {
      DefaultButton,
      InformationBox
    },
    data: () => ({
      checkbox1:'',
      loading: false,
      vendor: '',
      vendorList: [],
    }),
    computed:{
      isComplete() {
        return this.checkbox1 && this.vendor
      },
      vendorOptions(){
        return this.vendorList.map((vendor) => vendor.name)
      },
        newAmount(){
            if(this.transaction.transaction.loaderAmount){
                return this.transaction.transaction.loaderAmount
            }
            else{
                return this.transaction.transaction.userAmount
            }
        },
         giftcardName() {
        return `${this.transaction.transaction.giftcard.name} ${this.transaction.transaction.giftcard.country.cca2} (${this.transaction.transaction.giftcard.country.currencySymbol}${this.transaction.transaction.giftcard.cardMin}
} - ${this.transaction.transaction.giftcard.country.currencySymbol}${this.transaction.transaction.giftcard.cardMax})}`
      }
    },
    methods:{
      async approveTrade(){
        try {
          this.loading = true;
          let payload = {
            trade : this.transaction.roomId,
            action : CloseTradeEnum.ACCEPT,
            vendor: this.vendor
          }
          console.log(payload)
          const data = await StoresService.closeTrade(payload);
          this.loading = false
          this.rate = ''
          this.$emit('closeModal',payload.trade)
          console.log(data);
          const result =  LogEvent( analytics,'giftcard_trade_success', { trade: "card" });
          
        const mix =  this.$mixpanel.track('giftcard_trade_success',{ trade: "card" });
       console.log("the result here", result, "check mix", mix);
        } catch (error) {
          this.loading = false
          console.log(error);
        }
      },
      async fetchVendors() {
      try {
       const data = await StoresService.loadGiftcardVendors();
        this.vendorList = data;
      } catch (error) {
        console.log(error);
      }
    },
    },
    mounted() {
      this.fetchVendors()
    },
    
  watch:{
  },
}
</script>